import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IOption } from '@cmps/ng-select';
import { tap } from 'rxjs/operators';

import { ConfigPath } from './config.insight.model';
import { TranslationKeyMap } from './insight.i18n';

@Component({
    selector: '[cmpsInsightPath]',
    templateUrl: './path.insight.component.html',
})
export class PathInsightComponent implements OnChanges, OnInit {
    @Input() paths: ConfigPath[];
    @Input() path: ConfigPath;
    @Output() pathChange: EventEmitter<ConfigPath>;
    i18n = TranslationKeyMap;
    form: FormGroup;
    pathOpts: IOption[];

    constructor(private readonly _formBuilder: FormBuilder) {
        this.pathChange = new EventEmitter();

        this.form = this._formBuilder.group({
            path: [null],
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('paths')) {
            this.pathOpts = this.paths.map((e) => ({
                value: e.pathIdentifier,
                label: e.name,
            }));
        }

        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('path')) {
            this.form.patchValue(
                {
                    path: this.path.pathIdentifier,
                },
                { emitEvent: false },
            );
        }
    }

    ngOnInit(): void {
        // TODO unsub
        this.form
            .get('path')
            .valueChanges.pipe(
                tap((value) => {
                    const path = this.paths.find(
                        (e) => e.pathIdentifier === value,
                    );
                    this.pathChange.emit(path);
                }),
            )
            .subscribe();
    }
}
